import axios from 'axios';
import useAgent from '../../../hooks/useAgent';

const url = (inventoryId, itemId) => `/api/v1/inventory/${inventoryId}/inventory-items/${itemId}/before-and-after`;
const getBeforeAndAfter = (iventoryId, itemId, date) => axios.get(url(iventoryId, itemId), { params: { date: `${date}` } });
const useGetBeforeAfter = () => useAgent(getBeforeAndAfter);

export default useGetBeforeAfter;
